import { storeToRefs } from 'pinia'
import { useMatchDetailStore } from 'wap/stores/matchDetail'

export default {
  props: {
    hasNew: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const matchDetailStore = useMatchDetailStore()
    const { commentaryBotStatus } = storeToRefs(matchDetailStore)

    const { updateCurrentFixedType, updateCurrentFixedId } = matchDetailStore

    return {
      commentaryBotStatus,
      updateCurrentFixedType,
      updateCurrentFixedId
    }
  },
  data() {
    return {
      padDiv: '',
      timer: '',
      timerFixed: '',
      isBottom: false
    }
  },
  computed: {
    visible() {
      const { data, currentFixedId, showFixed, commentaryBotStatus } = this
      return !!(data.id === currentFixedId && showFixed && commentaryBotStatus)
    }
  },
  watch: {
    showFixed(val) {
      if (val) {
        // 改变type 和 id
        this.updateCurrentFixedType(this.data.moduleType)
        this.updateCurrentFixedId(this.data.id)
      } else {
        this.isBottom = false
        this.updateCurrentFixedType()
        // this.updateCurrentFixedId()
      }
    },
    visible(val) {
      if (val) {
        // 固定底部
        if (this.data.moduleType === 4 && this.data.commentaryText.voucherType === 1) {
          // this.countDown(this.limitTime)
        } else {
          this.countDown()
        }
        if (this.data.moduleType === 2) this.needSlice = true
        this.slideLeftShow()
        // 添加滚动事件 监听用户查看历史翻找
        window.addEventListener('scroll', this.handleScroll)
      } else {
        // 清除倒计时 因为有可能是 id 不一样导致false
        this.timer && clearInterval(this.timer)
        // 清除滚动时间
        window.removeEventListener('scroll', this.handleScroll)
        if (this.commentaryBotStatus) {
          this.slideRightHide()
        } else {
          this.toLittleHide()
        }
      }
    }
  },
  mounted() {
    if (this.data.isPushMsg && this.commentaryBotStatus && !this.hasNew) {
      // 这部分也许还需要添加条件 注意！！！！
      if (this.data.moduleType !== 3) {
        this.judgePosition()
      }
    }
  },
  methods: {
    countDown() {
      this.timer = setInterval(() => {
        this.fixedLeftTime--
        if (this.fixedLeftTime <= 0) {
          clearInterval(this.timer)
        }
      }, 1000)
    },
    judgePosition() {
      const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      this.timerFixed = setInterval(() => {
        if (this.hasNew || !this.$el) {
          clearInterval(this.timerFixed)
          return false
        }
        // fix: t.$el.getBoundingClientRect is not a function
        if (!this.$el) return false
        const eleTop = this.$el.getBoundingClientRect().top
        if (eleTop + 60 >= windowHeight) {
          if (this.compPriority() && this.commentaryBotStatus) {
            // 优先级高 则true
            this.isBottom = true
          }
          clearInterval(this.timerFixed)
        }
      }, 1000)
    },
    handleScroll() {
      const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      let eleTop
      if (this.padDiv) eleTop = this.padDiv.getBoundingClientRect().top
      else eleTop = this.$el ? this.$el.getBoundingClientRect().top : 0

      // 已经固定在底部 用户上滑查看之前的
      if (eleTop + 60 <= windowHeight && this.padDiv) {
        this.isBottom = false
      }
    },
    slideLeftShow() {
      const el = this.$el
      this.padDiv = document.createElement('div')

      // 获取该元素宽高
      const width = el.clientWidth
      const height = el.clientHeight
      // 占位元素宽高定义
      this.padDiv.style.width = `${width}px`
      this.padDiv.style.height = `${height}px`

      // 添加类名  应用底部固定样式
      el.classList.add('fixed-bottom')

      // 添加过渡动画
      let speed = -100
      const _timer = setInterval(() => {
        speed += 10
        el.style.transform = `translateX(${speed}%)`
        if (speed >= 0) {
          clearInterval(_timer)
        }
      }, 30)

      // 占位元素嵌入
      const parent = el.parentNode
      parent && parent.insertBefore(this.padDiv, el)
    },
    slideRightHide() {
      const el = this.$el
      // 删除占位元素
      if (this.padDiv) {
        this.padDiv.parentNode.removeChild(this.padDiv)
        this.padDiv = ''
      }
      // 动画
      let speed = 0
      const _timer = setInterval(() => {
        speed += 10
        el.style.transform = `translateX(${speed}%)`
        if (speed >= 100) {
          el.style.transform = 'translateX(0)'
          el.classList.remove('fixed-bottom')
          clearInterval(_timer)
          if (this.data.moduleType === 2) this.needSlice = false
        }
      }, 30)
    },
    toLittleHide() {
      const el = this.$el
      el.classList.add('scale-bottom-right')
      if (this.padDiv) {
        this.padDiv.parentNode.removeChild(this.padDiv)
        this.padDiv = ''
      }
      setTimeout(() => {
        el.classList.remove('fixed-bottom')
        el.classList.remove('scale-bottom-right')
        el.style.transform = 'translateX(0)'
        this.isBottom = false
        if (this.data.moduleType === 2) this.needSlice = false
      }, 500)
    }
  }
}
